import { Controller } from 'react-hook-form'

import { useFormContextContact } from '../_utils'
import ContactFormField from '../ContactFormField'

const Profession = () => {
    const { control } = useFormContextContact()

    return (
        <Controller
            control={control}
            name="profession"
            render={({ field, fieldState: { error } }) => (
                <ContactFormField
                    variant="input"
                    label="Profession"
                    disabled
                    status={{
                        error,
                        valid: Boolean(field.value),
                    }}
                    size="0.5"
                    dataCyScope="ContactField"
                    {...field}
                    onChange={(e) => {
                        field.onChange(e)
                    }}
                    value={field.value ?? ''}
                    placeholder="Profession"
                />
            )}
        />
    )
}

export default Profession
